export default "__VITE_ASSET__ChyRmM3___"